import api from '../../../core/api/client';

const normalizeList = (data) =>
  Array.isArray(data) ? data : (data?.activities ?? data?.data ?? []);

export const activitiesService = {
  async getRecentActivities(limit = 50) {
    const res = await api.get('/activities/recent', { params: { limit } });
    return normalizeList(res.data);
  },

  async getMyActivities(limit = 50) {
    const res = await api.get('/activities/me', { params: { limit } });
    return normalizeList(res.data);
  },

  async getUserActivities(userId, limit = 50) {
    const res = await api.get(`/activities/users/${userId}`, { params: { limit } });
    return normalizeList(res.data);
  },

  async getProjectActivities(projectId, limit = 100) {
    const res = await api.get(`/activities/projects/${projectId}`, { params: { limit } });
    return normalizeList(res.data);
  },
};
